import MiniBox from "../../componets/MiniBox";
import benefitsData from "../../data/staffAugmentationServiceBenefits.json";

export default function Section5() {
  return (
    <div className="Section5 p-[2%] my-[40px] md:mb-[4%] md:mt-[5%] text-center bg-[url('/public/assets/magento-rectangle.png')]">
      <h2 className="text-[24px] leading-[32px] md:text-[34px] font-bold md:leading-[41px] text-white my-[0.67em]">
        Straight Simple Smooth
      </h2>

      <MiniBox
        data={benefitsData}
        containerStyle="w-[80%] flex flex-col md:flex-row flex-nowrap mb-[10px] pt-0 md:pt-5"
        boxStyle="w-full md:w-[33.33%] p-[15px_20px] m-[10px_8px]"
        headingStyle="text-black"
        textStyle="text-[#373737] text-[14px]"
      />
    </div>
  );
}
